
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91jobSlug_93dIEd8rusCmtHJQ3fSanFd6ola8e6wkmHUqa5OygufCYMeta } from "/codebuild/output/src118217614/src/nuxt/pages/jobs/[jobSlug].vue?macro=true";
import { default as about_45us6gwNmXruEhsy7rcDN4WmLYL_hlPjwt2FSscXsjNDFMQMeta } from "/codebuild/output/src118217614/src/nuxt/pages/about-us.vue?macro=true";
import { default as clients8xRD3NMC8oFYGBZ0sMLPP5XVW_JzvaIG7QiUeSRxgJMMeta } from "/codebuild/output/src118217614/src/nuxt/pages/clients.vue?macro=true";
import { default as contactBbdETxObP_KIRa5E5Y9VE4AKCbbFuXKmm9drztJ5tyEMeta } from "/codebuild/output/src118217614/src/nuxt/pages/contact.vue?macro=true";
import { default as indexwC3jnq4A7g56_wli8PE80sLD9IiL4FP96G4yZc81BY0Meta } from "/codebuild/output/src118217614/src/nuxt/pages/jobs/index.vue?macro=true";
import { default as terms3AhfXZKuyVbGMMyG2rtYEfxb4rfUmoB0LKEA5fEb9oAMeta } from "/codebuild/output/src118217614/src/nuxt/pages/terms.vue?macro=true";
import { default as indexqC3EEVNKYQlNLp2gGKZPvdjrWubFuS0fcNmsuTDenMQMeta } from "/codebuild/output/src118217614/src/nuxt/pages/index.vue?macro=true";
export default [
  {
    name: "jobs-jobSlug",
    path: "/jobs/:jobSlug()",
    component: () => import("/codebuild/output/src118217614/src/nuxt/pages/jobs/[jobSlug].vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/codebuild/output/src118217614/src/nuxt/pages/about-us.vue")
  },
  {
    name: "clients",
    path: "/clients",
    component: () => import("/codebuild/output/src118217614/src/nuxt/pages/clients.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src118217614/src/nuxt/pages/contact.vue")
  },
  {
    name: "jobs",
    path: "/jobs",
    component: () => import("/codebuild/output/src118217614/src/nuxt/pages/jobs/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/codebuild/output/src118217614/src/nuxt/pages/terms.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src118217614/src/nuxt/pages/index.vue")
  }
]